/**
 * ONE height animator for every growth of the composer pill: the pill<->card
 * morph, each new list point, send-clear. Web Animations API,
 * interruption-safe — a new line landing mid-tween continues from the height
 * on screen instead of snapping (the "bump" a style/timeout tween produces,
 * founder-hit on the mockup 08-13). Layout itself always rests at height:auto.
 */
export interface HeightAnimator {
  /** Animate the host to its natural height, optionally applying `mutate`
   *  (class flips / DOM changes) between measuring and animating. */
  animate(mutate?: () => void): void;
}

export function createHeightAnimator(hostRef: {
  current: HTMLElement | null;
}): HeightAnimator {
  let anim: Animation | null = null;
  let lastH = 0;
  return {
    animate(mutate?: () => void) {
      const host = hostRef.current;
      if (!host || typeof host.animate !== "function") {
        mutate?.();
        return;
      }
      const seen = host.getBoundingClientRect().height;
      if (anim) {
        anim.cancel();
        anim = null;
      }
      mutate?.();
      const natural = host.offsetHeight;
      // No mutate + an already-settled reading means the DOM grew before we
      // looked: the true visual origin is the last resting height we recorded.
      let from = seen;
      if (!mutate && Math.abs(seen - natural) < 0.5) from = lastH || seen;
      if (from > 0 && Math.round(from) !== Math.round(natural)) {
        anim = host.animate(
          [{ height: `${from}px` }, { height: `${natural}px` }],
          { duration: 300, easing: "cubic-bezier(.32,.72,.28,1)" }
        );
        anim.onfinish = () => {
          anim = null;
        };
      }
      lastH = natural;
    },
  };
}
